module.exports = __webpack_public_path__ + "img/release.cf17c1a2.png";